import { FormattedMessage, useIntl } from 'react-intl';

import { NamePromptModal } from '../../components/name-prompt-modal/name-prompt-modal.component';

const ID = 'select-courier-other-modal';

export interface SelectCourierOtherModalProps {
    show: boolean;
    value: string;
    isSubmitting: boolean;
    onChange: (value: string) => void;
    onClose: () => void;
    onSubmit: () => void;
}

export const SelectCourierOtherModal = (props: SelectCourierOtherModalProps) => {
    const intl = useIntl();

    return (
        <NamePromptModal
            id={ID}
            show={props.show}
            value={props.value}
            isSubmitting={props.isSubmitting}
            title={
                <FormattedMessage
                    id='kiosk.wizard.select-courier.other-modal.title'
                    defaultMessage='Who is dropping off?'
                    description='Title of the Other courier modal asking for name or company'
                />
            }
            placeholder={intl.formatMessage({
                id: 'kiosk.wizard.select-courier.other-modal.placeholder',
                defaultMessage: 'Name or company',
                description: 'Placeholder for name or company on the Other courier modal'
            })}
            onChange={props.onChange}
            onClose={props.onClose}
            onSubmit={props.onSubmit}
        />
    );
};
